import react from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import Unauthorized from "../general/Unauthorized";
import { Modal, Button } from "react-bootstrap";
import { validarArchivoEsImagen } from "../../../resources/Helper";
import { resizeImage } from "../../../utils/imageHelpers";
import SelectorHora from "../general/SelectorHora";
import { getElementosHora, escolaridades } from "../../../resources/Helper";
import SelectorPais from "../custom/SelectorPais";
import SelectorCiudad from "../custom/SelectorCiudad";
import SelectorProfesionalAsignado from "../custom/SelectorProfesionalAsignado";
import SelectorVinculacion from "../custom/SelectorVinculacion";
import SelectorEPS from "../custom/SelectorEPS";
import SelectorTipoDocumento from "../custom/SelectorTipoDocumento";
import SelectorZona from "../custom/SelectorZona";
import { baseUrl } from "../../../resources/Constants";

const formatearFechaIngresoParaInput = (valor) => {
    if (!valor) return "";
    const texto = String(valor).trim();
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(texto)) return texto.slice(0, 16);
    const normalizado = texto.replace(" ", "T");
    const d = new Date(normalizado);
    if (Number.isNaN(d.getTime())) return texto.slice(0, 16);
    const p = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
};

function EditarPaciente() {

    const [primerNombre, setPrimerNombre] = useState('');
    const [segundoNombre, setSegundoNombre] = useState('');
    const [primerApellido, setPrimerApellido] = useState('');
    const [segundoApellido, setSegundoApellido] = useState('');
    const [fechaIngreso, setFechaIngreso] = useState('');
    const [numeroDocumento, setNumeroDocumento] = useState('');
    const [tipoDocumento, setTipoDocumento] = useState('');
    const [genero, setGenero] = useState('');
    const [tipoSangre, setTipoSangre] = useState('');
    const [estadoCivil, setEstadoCivil] = useState('');
    const [fechaNacimiento, setFechaNacimiento] = useState('');
    const [paisNacimiento, setPaisNacimiento] = useState('');
    const [ciudadNacimiento, setCiudadNacimiento] = useState('');
    const [nombreCiudadExterior, setNombreCiudadExterior] = useState('');
    const [ocupacion, setOcupacion] = useState('');
    const [nacionalidad, setNacionalidad] = useState('');
    const [estadoPaciente, setEstadoPaciente] = useState('');
    const [etnia, setEtnia] = useState('');
    const [raza, setRaza] = useState('');
    const [escolaridad, setEscolaridad] = useState('');
    const [direccion, setDireccion] = useState('');
    const [pais, setPais] = useState('');
    const [ciudad, setCiudad] = useState('');
    const [zona, setZona] = useState('');
    const [telefono, setTelefono] = useState('');
    const [celular, setCelular] = useState('');
    const [email, setEmail] = useState('');
    const [paisResidencia, setPaisResidencia] = useState('');
    const [vinculacion, setVinculacion] = useState('');
    const [eps, setEps] = useState('');
    const [clasificacion, setClasificacion] = useState('');
    const [convenio, setConvenio] = useState('');
    const [medioPublicitario, setMedioPublicitario] = useState('');
    const [referido, setReferido] = useState('');
    const [nombreAcompanante, setNombreAcompanante] = useState('');
    const [telefonoAcompanante, setTelefonoAcompanante] = useState('');
    const [parentescoAcompanante, setParentescoAcompanante] = useState('');
    const [docAcompanante, setDocAcompanante] = useState('');
    const [emailAcompanante, setEmailAcompanante] = useState('');
    const [nombreResponsable, setNombreResponsable] = useState('');
    const [telefonoResponsable, setTelefonoResponsable] = useState('');
    const [docResponsable, setDocResponsable] = useState('');
    const [emailResponsable, setEmailResponsable] = useState('');
    const [parentescoResponsable, setParentescoResponsable] = useState('');
    const [nombreMadre, setNombreMadre] = useState('');
    const [documentoMadre, setDocumentoMadre] = useState('');
    const [telefonoMadre, setTelefonoMadre] = useState('');
    const [ocupacionMadre, setOcupacionMadre] = useState('');
    const [nombrePadre, setNombrePadre] = useState('');
    const [documentoPadre, setDocumentoPadre] = useState('');
    const [telefonoPadre, setTelefonoPadre] = useState('');
    const [ocupacionPadre, setOcupacionPadre] = useState('');
    const [clasificacionRiesgo, setClasificacionRiesgo] = useState('');
    const [descripcionClasificacion, setDescripcionClasificacion] = useState('');
    const queryParams = useLocation().search;
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(true);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [aseguradoras, setAseguradoras] = useState([]);
    const [convenios, setConvenios] = useState([]);
    const [mediosPublicitarios, setMediosPublicitarios] = useState([]);
    const paciente_id = new URLSearchParams(queryParams).get('id');
    const [pacienteId, setPacienteId] = useState(new URLSearchParams(queryParams).get('id'));
    const [idPaisNacimiento, setIdPaisNacimiento] = useState();
    const [idCiudadNacimiento, setIdCiudadNacimiento] = useState();
    const [idCiudad, setIdCiudad] = useState();
    const [idNacionalidad, setIdNacionalidad] = useState();
    const [idPaisResidencia, setIdPaisResidencia] = useState();
    const [horaNacimiento, setHoraNacimiento] = useState();
    const [identidadGenero, setIdentidadGenero] = useState();
    const [profesionalAsignado, setProfesionalAsignado] = useState('');
    const [discapacidad, setDiscapacidad] = useState('08');
    const [causaAtencion, setCausaAtencion] = useState();
    const [tecnologiaSalud, setTecnologiaSalud] = useState();
    const [finalidadTecnologiaSalud, setFinalidadTecnologiaSalud] = useState();
    const [componenteHoraNacimiento, setComponenteHoraNacimiento] = useState({});
    const [componenteMinutoNacimiento, setComponenteMinutoNacimiento] = useState({});
    const [componenteAmpmNacimiento, setComponenteAmpmNacimiento] = useState({});
    const [nombreOcupacion, setNombreOcupacion] = useState('');
    const [religion, setReligion] = useState('');
    const [errorlist, setErrorlist] = useState({});
    const errorSummaryRef = useRef(null);

    const [perfilimg, setPerfilimg] = useState('/dist/img/user-default.jpg');
    const [imgperfildata, setImgperfildata] = useState('');
    const [btnstate, setBtnstate] = useState(true);
    const [btnclass, setBtnclass] = useState('btn btn-primary btn-disabled');



    const [verDescripcionClasificacion, setVerDescripcionClasificacion] = useState('hide');

    // Estados para controlar acordeones
    const [acordeonDatosPersonales, setAcordeonDatosPersonales] = useState(true);
    const [acordeonDomicilio, setAcordeonDomicilio] = useState(false);
    const [acordeonDatosAdicionales, setAcordeonDatosAdicionales] = useState(false);
    const [acordeonAcompanante, setAcordeonAcompanante] = useState(false);
    const [acordeonResponsable, setAcordeonResponsable] = useState(false);
    const [acordeonMenores, setAcordeonMenores] = useState(false);

    let history = useHistory();
    let userdata = [];


    const [mensajeModal, setMensajeModal] = useState('');
    const [showModal, setShowModal] = useState(false);
    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);
    const rutaAtenderPaciente = (() => {
        const idDestino = pacienteId || paciente_id;
        return idDestino ? `/atender-paciente?id=${idDestino}` : '/atender-paciente';
    })();
    const handleAtenderPaciente = () => history.push(rutaAtenderPaciente);


    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso a editar pacientes
        const tienePermiso = userdata.up && userdata.up.includes('crearPacientes');

        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token,
            },
            params: {
                uid: userdata.user_id,
                id: paciente_id
            }
        }


        axios.get(`paciente?uid=${userdata.user_id}&id=${paciente_id}`, config2)
            .then(response => {
                asignarInfoPaciente(response.data);
            })
            .catch(error => console.log(error));

        // Cargar aseguradoras, convenios y medios publicitarios con axios
        axios.get('/aseguradoras')
            .then(response => {
                if (response.status === 200) {
                    setAseguradoras(response.data);
                }
            })
            .catch(error => {
                console.error('Error cargando aseguradoras:', error);
            });

        axios.get('/convenios')
            .then(response => {
                if (response.status === 200) {
                    setConvenios(response.data);
                }
            })
            .catch(error => {
                console.error('Error cargando convenios:', error);
            });

        axios.get('/medios-publicitarios')
            .then(response => {
                if (response.status === 200) {
                    setMediosPublicitarios(response.data);
                }
            })
            .catch(error => {
                console.error('Error cargando medios publicitarios:', error);
            });
    }, []);



    const asignarInfoPaciente = (response) => {
        if (response && response[0] && response[0].id) {
            setPacienteId(response[0].id);
        }

        setPrimerNombre(response[0].primer_nombre || '');
        setSegundoNombre(response[0].segundo_nombre || '');
        setPrimerApellido(response[0].primer_apellido || '');
        setSegundoApellido(response[0].segundo_apellido || '');
        setNumeroDocumento(response[0].numero_documento || '');
        setTipoDocumento(response[0].tipo_documento || '');
        setEmail(response[0].email || '');
        setCelular(response[0].celular || '');
        setGenero(response[0].sexo || '');
        setTipoSangre(response[0].rh || '');
        setEstadoCivil(response[0].estado_civil || '');
        setFechaNacimiento(response[0].fecha_nacimiento || '');
        setFechaIngreso(formatearFechaIngresoParaInput(response[0].fechaingreso));
        setCiudadNacimiento(response[0].ciudad_nacimiento || '');
        setOcupacion(response[0].ocupacion || '');
        setNombreOcupacion(response[0].nombre_ocupacion || '');
        setReligion(response[0].religion || '');
        setEtnia(response[0].etnia || '');
        setRaza(response[0].raza || '');
        setEscolaridad(response[0].escolaridad || '');
        setNacionalidad(response[0].nacionalidad || '');
        setDireccion(response[0].direccion || '');
        setCiudad(response[0].ciudad || '');
        setZona(response[0].zona || '');
        setTelefono(response[0].telefono || '');
        setVinculacion(response[0].vinculacion || '');
        setEps(response[0].eps || '');
        setClasificacionRiesgo(response[0].clasificacion_riesgo || '');
        setDescripcionClasificacion(response[0].descripcion_clasificacion || '');
        setMedioPublicitario(response[0].medio_publicitario || '');
        setReferido(response[0].referido_por || '');
        setNombreAcompanante(response[0].nombre_acompanante || '');
        setTelefonoAcompanante(response[0].telefono_acompanante || '');
        setDocAcompanante(response[0].doc_acompanante || '');
        setEmailAcompanante(response[0].email_acompanante || '');
        setParentescoAcompanante(response[0].parentesco_acompanante || '');
        setNombreResponsable(response[0].nombre_responsable || '');
        setTelefonoResponsable(response[0].telefono_responsable || '');
        setDocResponsable(response[0].doc_responsable || '');
        setEmailResponsable(response[0].email_responsable || '');
        setParentescoResponsable(response[0].parentesco_responsable || '');
        setNombreMadre(response[0].nombre_madre || '');
        setDocumentoMadre(response[0].documento_madre || '');
        setTelefonoMadre(response[0].telefono_madre || '');
        setOcupacionMadre(response[0].ocupacion_madre || '');
        setNombrePadre(response[0].nombre_padre || '');
        setDocumentoPadre(response[0].documento_padre || '');
        setTelefonoPadre(response[0].telefono_padre || '');
        setOcupacionPadre(response[0].ocupacion_padre || '');
        setEstadoPaciente(response[0].estado || '');
        setConvenio(response[0].convenio || '');
        setHoraNacimiento(response[0].hora_nacimiento || '');
        setIdentidadGenero(response[0].identidad_genero || '');
        setProfesionalAsignado(response[0].id_users || '');

        setCausaAtencion(response[0].causa_atencion || '');
        setTecnologiaSalud(response[0].tecnologia_salud || '');
        setFinalidadTecnologiaSalud(response[0].finalidad_tecnologia_salud || '');

        setPaisNacimiento(response[0].nombre_pais_nacimiento || '');
        setIdPaisNacimiento(response[0].id_pais_nacimiento || '');

        setIdCiudadNacimiento(response[0].id_ciudad_nacimiento || '');
        setCiudadNacimiento(response[0].nombre_ciudad_nacimiento || '');

        setIdCiudad(response[0].id_ciudad_residencia || '');
        setCiudad(response[0].nombre_ciudad_residencia || '');

        setPaisResidencia(response[0].nombre_pais_residencia || '');
        setIdPaisResidencia(response[0].id_pais_residencia || '');

        setNacionalidad(response[0].nombre_pais_nacionalidad || '');
        setIdNacionalidad(response[0].id_pais_nacionalidad || '');

        if (response[0].discapacidad) {
            setDiscapacidad(response[0].discapacidad);
        }

        if (response[0].imagen_perfil) {
            // El backend ya devuelve la URL completa con asset()
            console.log('📸 Imagen del paciente encontrada:', response[0].imagen_perfil);
            setPerfilimg(response[0].imagen_perfil);
        } else {
            console.log('⚠️ No hay imagen_perfil en la respuesta del backend');
        }

        if (response[0].hora_nacimiento) {
            let componentesHoraNacimiento = getElementosHora(response[0].hora_nacimiento);
            setComponenteHoraNacimiento(componentesHoraNacimiento[0]);
            setComponenteMinutoNacimiento(componentesHoraNacimiento[1]);
            setComponenteAmpmNacimiento(componentesHoraNacimiento[2]);
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorlist({});

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        let hnc = (componenteAmpmNacimiento == 'pm' && parseInt(componenteHoraNacimiento) < 12) ? parseInt(componenteHoraNacimiento) + 12 : componenteHoraNacimiento;

        let hn = hnc + ':' + componenteMinutoNacimiento;

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            client_id: userdata.client_id,
            id: pacienteId,
            primer_nombre: primerNombre,
            segundo_nombre: segundoNombre,
            primer_apellido: primerApellido,
            segundo_apellido: segundoApellido,
            numero_documento: numeroDocumento,
            tipo_documento: tipoDocumento,
            email: email,
            celular: celular,
            sexo: genero,
            rh: tipoSangre,
            estado_civil: estadoCivil,
            fecha_nacimiento: fechaNacimiento,
            ciudad_nacimiento: idCiudadNacimiento,
            nombre_ciudad_exterior: nombreCiudadExterior,
            ocupacion: ocupacion,
            nombre_ocupacion: nombreOcupacion,
            religion: religion,
            etnia: etnia,
            raza: raza,
            escolaridad: escolaridad,
            nacionalidad: idNacionalidad,
            direccion: direccion,
            ciudad: idCiudad,
            zona: zona,
            telefono: telefono,
            celular: celular,
            email: email,
            vinculacion: vinculacion,
            eps: eps,
            clasificacion_riesgo: clasificacionRiesgo,
            descripcion_clasificacion: descripcionClasificacion,
            convenio: convenio,
            medio_publicitario: medioPublicitario,
            referido_por: referido,
            nombre_acompanante: nombreAcompanante,
            telefono_acompanante: telefonoAcompanante,
            doc_acompanante: docAcompanante,
            email_acompanante: emailAcompanante,
            parentesco_acompanante: parentescoAcompanante,
            nombre_responsable: nombreResponsable,
            telefono_responsable: telefonoResponsable,
            doc_responsable: docResponsable,
            email_responsable: emailResponsable,
            parentesco_responsable: parentescoResponsable,
            nombre_madre: nombreMadre,
            documento_madre: documentoMadre,
            telefono_madre: telefonoMadre,
            ocupacion_madre: ocupacionMadre,
            nombre_padre: nombrePadre,
            documento_padre: documentoPadre,
            telefono_padre: telefonoPadre,
            ocupacion_padre: ocupacionPadre,
            estado: '1',
            pais_nacimiento: idPaisNacimiento,
            pais_residencia: idPaisResidencia,
            hora_nacimiento: hn,
            identidad_genero: identidadGenero,
            id_users: profesionalAsignado || null,
            discapacidad: discapacidad,
            causa_atencion: '38',
            tecnologia_salud: '01',
            finalidad_tecnologia_salud: '12',
            componente_hora_nacimiento: componenteHoraNacimiento,
            componente_minuto_nacimiento: componenteMinutoNacimiento,
            componente_ampm_nacimiento: componenteAmpmNacimiento
        }

        console.log(config);

        ///////////////////////////

        if (imgperfildata) {
            const formData = new FormData();

            formData.append('image', imgperfildata);
            formData.append('id', pacienteId);

            axios.post('/fotoperfil-paciente', formData)
                .then(res => {
                    if (res.status === 200) {
                        setPerfilimg(res.data.url);
                    }
                })
                .catch(error => {
                    console.log(error);
                })
        }

        ///////////////////////////

        axios.put('/paciente', config)
            .then(response => {
                setLoading(false);
                if (response.status === 200) {
                    let np = segundoNombre ? primerNombre + ' ' + segundoNombre : primerNombre;
                    let pn1 = genero == 'h' ? 'del' : 'de la';
                    let pn2 = genero == 'h' ? 'al' : 'a la';

                    setMensajeModal('La información ' + pn1 + ' paciente ' + np + ' ' + primerApellido + ' ha sido completada. ¿Desea atender ' + pn2 + ' paciente?');

                    setTimeout(() => { handleShowModal() }, 1000);
                    setTimeout(() => { setEstadoPaciente('1') }, 1000);

                }
            })
            .catch(error => {
                setLoading(false);
                if (error.response && error.response.data && error.response.data.errors) {
                    setErrorlist(error.response.data.errors); // 👈 solo guardamos los errores
                } else {
                    setErrorlist({ general: 'Error inesperado, intente nuevamente' });
                }
            })
    }



    const agregarFotoPerfil = async (file) => {
        const selectedFile = file[0];
        
        if (!selectedFile) return;
        
        setErrorlist({});
        
        // Validar tipo de archivo
        if (!validarArchivoEsImagen(selectedFile)) {
            setErrorlist({ imagen_perfil: 'Tipo de archivo no válido' });
            setPerfilimg('/dist/img/user-default.jpg');
            return;
        }
        
        try {
            // Redimensionar imagen antes de guardarla
            const resizedBlob = await resizeImage(selectedFile, 800, 800, 0.8);
            
            // Crear File desde Blob para mantener compatibilidad
            const resizedFile = new File([resizedBlob], selectedFile.name, {
                type: selectedFile.type,
                lastModified: Date.now()
            });
            
            setImgperfildata(resizedFile);
            const f = URL.createObjectURL(resizedFile);
            setPerfilimg(f);
            setBtnstate(false);
            setBtnclass('btn btn-primary');
        } catch (error) {
            console.error('Error al procesar imagen:', error);
            setErrorlist({ imagen_perfil: 'Error al procesar la imagen' });
            setPerfilimg('/dist/img/user-default.jpg');
        }
    }


    useEffect(() => {

        if (imgperfildata) {
            if (!validarArchivoEsImagen(imgperfildata)) {
                setErrorlist({ imagen_perfil: 'Tipo de archivo no válido' });
                setPerfilimg('/dist/img/user-default.jpg');
            }
            // Ya no es necesario validar tamaño porque la imagen se redimensiona
        }
    }, [imgperfildata]);


    useEffect(() => {
        if (clasificacionRiesgo == 'medio' || clasificacionRiesgo == 'alto') {
            setVerDescripcionClasificacion('');
        }
        else {
            setVerDescripcionClasificacion('hide');
        }
    }, [clasificacionRiesgo]);



    useEffect(() => {
        if (Object.keys(errorlist).length > 0) {
            const timer = setTimeout(() => {
                setErrorlist({});
            }, 12000); // 12 segundos para permitir lectura

            return () => clearTimeout(timer);
        }
    }, [errorlist]);

    useEffect(() => {
        if (Object.keys(errorlist).length > 0 && errorSummaryRef.current) {
            errorSummaryRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            errorSummaryRef.current.focus({ preventScroll: true });
        }
    }, [errorlist]);




    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    // 🐛 DEBUG: Verificar valor de perfilimg antes del render
    console.log('🖼️ Valor actual de perfilimg antes del render:', perfilimg);

    if (loggedIn) {


        return (

            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="patients" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb bg-transparent p-0 mb-1">
                                        <li className="breadcrumb-item small"><Link to="/home" className="text-info">Home</Link></li>
                                        <li className="breadcrumb-item small"><Link to="/menu-pacientes" className="text-info">Pacientes</Link></li>
                                        <li className="breadcrumb-item small"><Link to="/pacientes" className="text-info">Listado</Link></li>
                                        <li className="breadcrumb-item small active">Editar</li>
                                    </ol>
                                    {Object.keys(errorlist).length > 0 && (
                                        <div
                                            ref={errorSummaryRef}
                                            tabIndex="-1"
                                            className="alert alert-danger alert-dismissible fade show"
                                            role="alert"
                                        >
                                            <button type="button" className="close" aria-label="Cerrar" onClick={() => setErrorlist({})}>
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                            <ul className="mb-0">
                                                {Object.values(errorlist).map((messages, index) => (
                                                    <li key={index}>{messages[0]}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}

                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0" style={{ fontSize: '1.6rem', color: '#323a45' }}>Editar Paciente</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <form id="role-form" onSubmit={handleSubmit} autoComplete="off">
                                <p className="text-muted small mb-3">
                                    Los campos marcados con <span className="text-danger">*</span> son obligatorios.
                                </p>
                                <div className="row">
                                    <div className="col-md-12">

                                        <div className="card">
                                            <div className="card-header">
                                                <h4 className="card-title w-100">
                                                    <button
                                                        type="button"
                                                        className="btn btn-link d-block w-100 text-left p-0"
                                                        onClick={() => setAcordeonDatosPersonales(!acordeonDatosPersonales)}
                                                        aria-expanded={acordeonDatosPersonales}
                                                        style={{ textDecoration: 'none', color: 'inherit' }}
                                                    >
                                                        <i className="fas fa-id-card-alt mr-2 text-info"></i>
                                                        Datos Personales
                                                    </button>
                                                </h4>
                                            </div>
                                            <div className={`collapse ${acordeonDatosPersonales ? 'show' : ''}`}>
                                                <div className="paciente-img" style={{ padding: '20px', marginTop: '36px' }}>
                                                    <div className="paciente-profile-img-container">
                                                        <img 
                                                            src={perfilimg} 
                                                            className="profile-img" 
                                                            alt="Foto del paciente"
                                                            style={{ 
                                                                zIndex: 10,
                                                                position: 'absolute',
                                                                width: '100%',
                                                                height: '100%',
                                                                objectFit: 'cover'
                                                            }}
                                                            onError={(e) => {
                                                                console.error('❌ Error cargando imagen:', e.target.src);
                                                                e.target.onerror = null;
                                                                e.target.src = '/dist/img/user-default.jpg';
                                                            }}
                                                            onLoad={() => {
                                                                console.log('✅ Imagen cargada exitosamente:', perfilimg);
                                                            }}
                                                        />
                                                        <input type="file" name="perfilimg" id="perfilimg" className="form-control profile-img-control" accept=".jpg, .png, .jpeg" onChange={(e) => agregarFotoPerfil(e.target.files)} />
                                                    </div>
                                                    <label htmlFor="perfilimg" className="lbl-cargar-foto-perfil">Cargar imagen</label>
                                                    <div className="invalid-feedback visible">
                                                        {errorlist.imagen_perfil}
                                                    </div>
                                                </div>
                                                <div className="card-body paciente-meta paciente-meta-editar">

                                                    <div className="row">
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="fechaIngreso">Fecha de ingreso</label>
                                                                <input
                                                                    type="datetime-local"
                                                                    name="fecha-ingreso"
                                                                    className="form-control"
                                                                    id="fechaIngreso"
                                                                    value={fechaIngreso}
                                                                    readOnly
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="companyName">Primer nombre <span className="text-danger">*</span></label>
                                                                <input type="text" name="company-name" className={`form-control ${errorlist.primer_nombre ? 'is-invalid' : ''}`} id="companyName" value={primerNombre} onChange={(e) => setPrimerNombre(e.target.value)} />
                                                                <div className="invalid-feedback visible">
                                                                    {errorlist.primer_nombre}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="companyName">Segundo nombre</label>
                                                                <input type="text" name="company-name" className="form-control" id="companyName" value={segundoNombre} onChange={(e) => setSegundoNombre(e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="companyName">Primer apellido</label>
                                                                <input type="text" name="company-name" className="form-control" id="companyName" value={primerApellido} onChange={(e) => setPrimerApellido(e.target.value)} />
                                                                <div className="invalid-feedback visible">
                                                                    {errorlist.primer_apellido}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div className="row">
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="companyName">Segundo apellido</label>
                                                                <input type="text" name="company-name" className="form-control" id="companyName" value={segundoApellido} onChange={(e) => setSegundoApellido(e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <SelectorTipoDocumento
                                                                value={tipoDocumento}
                                                                onChange={setTipoDocumento}
                                                                error={errorlist.tipo_documento}
                                                                required={true}
                                                            />
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="companyName">Número de documento <span className="text-danger">*</span></label>
                                                                <input type="text" name="company-name" className={`form-control ${errorlist.numero_documento ? 'is-invalid' : ''}`} id="companyName" value={numeroDocumento} onChange={(e) => setNumeroDocumento(e.target.value)} />
                                                                <div className="invalid-feedback visible">
                                                                    {errorlist.numero_documento}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="genero">Sexo biológico <span className="text-danger">*</span></label>
                                                                <select name="genero" className="form-control" id="genero" value={genero} onChange={(e) => setGenero(e.target.value)}>
                                                                    <option value=""></option>
                                                                    <option value="01">HOMBRE</option>
                                                                    <option value="02">MUJER</option>
                                                                </select>
                                                                <div className="invalid-feedback visible">
                                                                    {errorlist.sexo}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="identidad_genero">Identidad de género</label>
                                                                <select name="identidad_genero" className="form-control" id="identidad_genero" value={identidadGenero} onChange={(e) => setIdentidadGenero(e.target.value)}>
                                                                    <option value=""></option>
                                                                    <option value="01">MASCULINO</option>
                                                                    <option value="02">FEMENINO</option>
                                                                    <option value="03">TRANSGÉNERO</option>
                                                                    <option value="04">NEUTRO</option>
                                                                    <option value="05">NO LO DECLARA</option>
                                                                </select>
                                                                <div className="invalid-feedback visible">
                                                                    {errorlist.identidad_genero}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="tipoSangre">Tipo de sangre</label>
                                                                <select name="tipo-sangre" className="form-control" id="tipoSangre" value={tipoSangre} onChange={(e) => setTipoSangre(e.target.value)}>
                                                                    <option value=""></option>
                                                                    <option value="a+">A+</option>
                                                                    <option value="a-">A-</option>
                                                                    <option value="b+">B+</option>
                                                                    <option value="b-">B-</option>
                                                                    <option value="ab+">AB+</option>
                                                                    <option value="ab-">AB-</option>
                                                                    <option value="o+">O+</option>
                                                                    <option value="o-">O-</option>
                                                                </select>
                                                                <div className="invalid-feedback visible">
                                                                    {errorlist.rh}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="estadoCivil">Estado civil</label>
                                                                <select name="tipo-sangre" className="form-control" id="estadoCivil" value={estadoCivil} onChange={(e) => setEstadoCivil(e.target.value)}>
                                                                    <option value=""></option>
                                                                    <option value="soltero">SOLTERO</option>
                                                                    <option value="casado">CASADO</option>
                                                                    <option value="separado">SEPARADO</option>
                                                                    <option value="viudo">VIUDO</option>
                                                                    <option value="union_libre">UNIÓN LIBRE</option>
                                                                    <option value="otro">OTRO</option>
                                                                </select>
                                                                <div className="invalid-feedback visible">
                                                                    {errorlist.estado_civil}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="religion">Religión</label>
                                                                <input
                                                                    type="text"
                                                                    name="religion"
                                                                    className="form-control"
                                                                    id="religion"
                                                                    value={religion}
                                                                    onChange={(e) => setReligion(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="fechaNacimiento">Fecha de nacimiento <span className="text-danger">*</span></label>
                                                                <input type="date" name="fecha-nacimiento" className={`form-control ${errorlist.fecha_nacimiento ? 'is-invalid' : ''}`} id="fechaNacimiento" value={fechaNacimiento} onChange={(e) => setFechaNacimiento(e.target.value)} />
                                                                <div className="invalid-feedback visible">
                                                                    {errorlist.fecha_nacimiento}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="paisNacimiento">País de nacimiento <span className="text-danger">*</span></label>
                                                                <SelectorPais
                                                                    value={idPaisNacimiento}
                                                                    onChange={(id) => setIdPaisNacimiento(id)}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="ciudadNacimiento">Ciudad de nacimiento</label>
                                                                <SelectorCiudad
                                                                    value={idCiudadNacimiento}
                                                                    onChange={(id) => setIdCiudadNacimiento(id)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="ocupacion">Ocupación</label>
                                                                <input
                                                                    type="text"
                                                                    name="nombreOcupacion"
                                                                    className="form-control"
                                                                    id="nombreOcupacion"
                                                                    value={nombreOcupacion}
                                                                    onChange={(e) => setNombreOcupacion(e.target.value)}
                                                                />
                                                                <div className="invalid-feedback visible">
                                                                    {errorlist.ocupacion}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-9">
                                                            <SelectorProfesionalAsignado
                                                                value={profesionalAsignado}
                                                                onChange={setProfesionalAsignado}
                                                                error={errorlist.id_users?.[0]}
                                                            />
                                                        </div>
                                                    </div>


                                                    <div className="row">
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="discapacidad">Discapacidad</label>
                                                                <select name="discapacidad" className="form-control" id="discapacidad" value={discapacidad} onChange={(e) => setDiscapacidad(e.target.value)}>
                                                                    <option value="01">FÍSICA</option>
                                                                    <option value="02">VISUAL</option>
                                                                    <option value="03">AUDITIVA</option>
                                                                    <option value="04">INTELECTUAL</option>
                                                                    <option value="05">SICOSOCIAL (MENTAL)</option>
                                                                    <option value="06">SORDOCEGUERA</option>
                                                                    <option value="07">MULTIPLE</option>
                                                                    <option value="08">NINGUNA</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="escolaridad">Escolaridad</label>
                                                                <select name="escolaridad" className="form-control" id="escolaridad" value={escolaridad} onChange={(e) => setEscolaridad(e.target.value)}>
                                                                    <option></option>
                                                                    {
                                                                        escolaridades.map((item) => <option value={item.id}>{item.nombre}</option>)
                                                                    }
                                                                </select>
                                                                <div className="invalid-feedback visible">
                                                                    {errorlist.escolaridad}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="Etnia">Etnia</label>
                                                                <select name="etnia" className="form-control" id="Etnia" value={etnia} onChange={(e) => setEtnia(e.target.value)}>
                                                                    <option></option>
                                                                    <option value="01">INDIGENA</option>
                                                                    <option value="02">ROM (GITANO)</option>
                                                                    <option value="03">RAIZAL</option>
                                                                    <option value="04">PALENQUERO</option>
                                                                    <option value="05">NEGRO</option>
                                                                    <option value="06">AFROCOLOMBIANO</option>
                                                                    <option value="99">NINGUNA DE LAS ANTERIORES</option>
                                                                </select>
                                                                <div className="invalid-feedback visible">
                                                                    {errorlist.etnia}
                                                                </div>
                                                            </div>
                                                        </div>




                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="clasificacion_paciente">Clasificación</label>
                                                                <select name="clasificacion_paciente" className="form-control" id="clasificacion_paciente" value={clasificacion} onChange={(e) => setClasificacion(e.target.value)}>
                                                                    <option value="0">INACTIVO</option>
                                                                    <option value="1">ACTIVO</option>
                                                                    <option value="2">TERMINADO</option>
                                                                    <option value="3">FALLECIDO</option>
                                                                    <option value="4">PENDIENTE POR INICIAR</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row">



                                                        {/*<div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="raza">Raza</label>
                                                                <input type="text" name="raza" id="raza" className="form-control" defaultValue={raza} onChange={(e) => setRaza(e.target.value)} />
                                                                <div className="invalid-feedback visible">
                                                                {errorlist.raza}
                                                                </div>
                                                            </div>
                                                        </div>*/}
                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                        <div className="card">
                                            <div className="card-header">
                                                <h4 className="card-title w-100">
                                                    <button
                                                        type="button"
                                                        className="btn btn-link d-block w-100 text-left p-0"
                                                        onClick={() => setAcordeonDomicilio(!acordeonDomicilio)}
                                                        aria-expanded={acordeonDomicilio}
                                                        style={{ textDecoration: 'none', color: 'inherit' }}
                                                    >
                                                        <i className="fas fa-map-marker-alt mr-2 text-info"></i>
                                                        Domicilio del Paciente
                                                    </button>
                                                </h4>
                                            </div>
                                            <div className={`collapse ${acordeonDomicilio ? 'show' : ''}`}>
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="direccionPaciente">Dirección <span className="text-danger">*</span></label>
                                                                <input type="text" name="direccion" className={`form-control ${errorlist.direccion ? 'is-invalid' : ''}`} id="direccionPaciente" value={direccion} onChange={(e) => setDireccion(e.target.value)} />
                                                                <div className="invalid-feedback visible">
                                                                    {errorlist.direccion}
                                                                </div>
                                                            </div>
                                                        </div>


                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="ciudadNacimiento">Ciudad de Residencia <span className="text-danger">*</span></label>
                                                                <SelectorCiudad
                                                                    value={idCiudad}
                                                                    onChange={(id) => setIdCiudad(id)}
                                                                />
                                                            </div>
                                                        </div>



                                                        <div className="col-md-3">
                                                            <SelectorZona
                                                                value={zona}
                                                                onChange={setZona}
                                                                error={errorlist.zona?.[0]}
                                                                required={true}
                                                            />
                                                        </div>

                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="paisResidencia">País <span className="text-danger">*</span></label>
                                                                <SelectorPais
                                                                    value={idPaisResidencia}
                                                                    onChange={(id) => setIdPaisResidencia(id)}
                                                                />
                                                                <div className="invalid-feedback visible">
                                                                    {errorlist.pais_residencia}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="telefono">Teléfono</label>
                                                                <input type="text" name="telefono" className={`form-control ${errorlist.telefono ? 'is-invalid' : ''}`} id="telefono" value={telefono} onChange={(e) => setTelefono(e.target.value)} />
                                                                <div className="invalid-feedback visible">
                                                                    {errorlist.telefono}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="celular">Celular</label>
                                                                <input type="text" name="celular" className={`form-control ${errorlist.celular ? 'is-invalid' : ''}`} id="celular" value={celular} onChange={(e) => setCelular(e.target.value)} />
                                                                <div className="invalid-feedback visible">
                                                                    {errorlist.celular}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="email">Email <span className="text-danger">*</span></label>
                                                                <input type="email" name="email" className={`form-control ${errorlist.email ? 'is-invalid' : ''}`} id="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                                                                <div className="invalid-feedback visible">
                                                                    {errorlist.email}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card">
                                            <div className="card-header">
                                                <h4 className="card-title w-100">
                                                    <button
                                                        type="button"
                                                        className="btn btn-link d-block w-100 text-left p-0"
                                                        onClick={() => setAcordeonDatosAdicionales(!acordeonDatosAdicionales)}
                                                        aria-expanded={acordeonDatosAdicionales}
                                                        style={{ textDecoration: 'none', color: 'inherit' }}
                                                    >
                                                        <i className="fas fa-layer-group mr-2 text-info"></i>
                                                        Datos adicionales
                                                    </button>
                                                </h4>
                                            </div>
                                            <div className={`collapse ${acordeonDatosAdicionales ? 'show' : ''}`}>
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <SelectorVinculacion
                                                                value={vinculacion}
                                                                onChange={setVinculacion}
                                                                error={errorlist.vinculacion?.[0]}
                                                            />
                                                        </div>
                                                        <div className="col-md-4">
                                                            <SelectorEPS
                                                                value={eps}
                                                                onChange={setEps}
                                                                error={errorlist.eps?.[0]}
                                                                aseguradoras={aseguradoras}
                                                            />
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="clasificacion_riesgo">Clasificación de riesgo</label>
                                                                <select name="clasificacion_riesgo" className="form-control" id="clasificacion_riesgo" value={clasificacionRiesgo} onChange={(e) => setClasificacionRiesgo(e.target.value)}>
                                                                    <option value=""></option>
                                                                    <option value="bajo">RIESGO BAJO</option>
                                                                    <option value="medio">RIESGO MEDIO</option>
                                                                    <option value="alto">RIESGO ALTO</option>
                                                                </select>
                                                                <div className="invalid-feedback visible">
                                                                    {errorlist.clasificacion_riesgo}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="riesgo">Convenio</label>
                                                                <select name="riesgo" className="form-control" id="riesgo" value={convenio} onChange={(e) => setConvenio(e.target.value)}>
                                                                    <option></option>
                                                                    {
                                                                        convenios.map((convenio) =>
                                                                            <option value={convenio.id}>{convenio.nombre}</option>
                                                                        )
                                                                    }
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="medio">Cómo se enteró</label>
                                                                <select name="medio" className="form-control" id="medio" value={medioPublicitario} onChange={(e) => setMedioPublicitario(e.target.value)}>
                                                                    <option value=""></option>
                                                                    {
                                                                        mediosPublicitarios.map((medio) =>
                                                                            <option value={medio.id}>{medio.nombre}</option>
                                                                        )
                                                                    }
                                                                </select>
                                                                <div className="invalid-feedback visible">
                                                                    {errorlist.medio_publicitario}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="referidoPor">Referido por</label>
                                                                <input type="text" name="referido-por" className="form-control" id="referidoPor" value={referido} onChange={(e) => setReferido(e.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={`row ${verDescripcionClasificacion}`}>
                                                        <div className="col-md-12">
                                                            <div className="form-group">
                                                                <label htmlFor="descripcion_clasificacion">Descripción clasificación</label>
                                                                <input type="text" name="descripcion_clasificacion" className="form-control" id="descripcion_clasificacion" value={descripcionClasificacion} onChange={(e) => setDescripcionClasificacion(e.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="card">
                                            <div className="card-header">
                                                <h4 className="card-title w-100">
                                                    <button
                                                        type="button"
                                                        className="btn btn-link d-block w-100 text-left p-0"
                                                        onClick={() => setAcordeonAcompanante(!acordeonAcompanante)}
                                                        aria-expanded={acordeonAcompanante}
                                                        style={{ textDecoration: 'none', color: 'inherit' }}
                                                    >
                                                        <i className="fas fa-user-friends mr-2 text-info"></i>
                                                        Acompañante
                                                    </button>
                                                </h4>
                                            </div>
                                            <div className={`collapse ${acordeonAcompanante ? 'show' : ''}`}>
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="nombreAcompanante">Nombre</label>
                                                                <input type="text" name="nombre_acompanante" className="form-control" id="nombreAcompanante" value={nombreAcompanante} onChange={(e) => setNombreAcompanante(e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="doc_acompanante">Número de documento</label>
                                                                <input type="text" name="doc_acompanante" className="form-control" id="doc_acompanante" value={docAcompanante} onChange={(e) => setDocAcompanante(e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="parentesco_acompanante">Parentesco</label>
                                                                <input type="text" name="parentesco_acompanante" className="form-control" id="parentesco_acompanante" value={parentescoAcompanante} onChange={(e) => setParentescoAcompanante(e.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="telefonoAcompanante">Teléfono</label>
                                                                <input type="text" name="telefono_acompanante" className="form-control" id="telefonoAcompanante" value={telefonoAcompanante} onChange={(e) => setTelefonoAcompanante(e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="email_acompanante">Email</label>
                                                                <input type="text" name="email_acompanante" className="form-control" id="email_acompanante" value={emailAcompanante} onChange={(e) => setEmailAcompanante(e.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card">
                                            <div className="card-header">
                                                <h4 className="card-title w-100">
                                                    <button
                                                        type="button"
                                                        className="btn btn-link d-block w-100 text-left p-0"
                                                        onClick={() => setAcordeonResponsable(!acordeonResponsable)}
                                                        aria-expanded={acordeonResponsable}
                                                        style={{ textDecoration: 'none', color: 'inherit' }}
                                                    >
                                                        <i className="fas fa-user-shield mr-2 text-info"></i>
                                                        Responsable
                                                    </button>
                                                </h4>
                                            </div>
                                            <div className={`collapse ${acordeonResponsable ? 'show' : ''}`}>
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="nombreResponsable">Nombre</label>
                                                                <input type="text" name="nombre_responsable" className="form-control" id="nombreResponsable" value={nombreResponsable} onChange={(e) => setNombreResponsable(e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="doc_responsable">Número de documento</label>
                                                                <input type="text" name="doc_responsable" className="form-control" id="doc_responsable" value={docResponsable} onChange={(e) => setDocResponsable(e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="parentesco_responsable">Parentesco</label>
                                                                <input type="text" name="parentesco_responsable" className="form-control" id="parentesco_responsable" value={parentescoResponsable} onChange={(e) => setParentescoResponsable(e.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="telefonoResponsable">Teléfono</label>
                                                                <input type="text" name="telefono_responsable" className="form-control" id="telefonoResponsable" value={telefonoResponsable} onChange={(e) => setTelefonoResponsable(e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="email_responsable">Email</label>
                                                                <input type="text" name="email_responsable" className="form-control" id="email_responsable" value={emailResponsable} onChange={(e) => setEmailResponsable(e.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>



                                        <div className="card">
                                            <div className="card-header">
                                                <h4 className="card-title w-100">
                                                    <button
                                                        type="button"
                                                        className="btn btn-link d-block w-100 text-left p-0"
                                                        onClick={() => setAcordeonMenores(!acordeonMenores)}
                                                        aria-expanded={acordeonMenores}
                                                        style={{ textDecoration: 'none', color: 'inherit' }}
                                                    >
                                                        <i className="fas fa-child mr-2 text-info"></i>
                                                        Información Adicional para Menores de Edad
                                                    </button>
                                                </h4>
                                            </div>
                                            <div className={`collapse ${acordeonMenores ? 'show' : ''}`}>
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="nombreMadre">Nombre de la madre</label>
                                                                <input type="text" name="nombre-madre" className="form-control" id="nombreMadre" value={nombreMadre} onChange={(e) => setNombreMadre(e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="docMadre">Número de documento</label>
                                                                <input type="text" name="doc-madre" className="form-control" id="docMadre" value={documentoMadre} onChange={(e) => setDocumentoMadre(e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="telMadre">Teléfono</label>
                                                                <input type="text" name="tel-madre" className="form-control" id="telMadre" value={telefonoMadre} onChange={(e) => setTelefonoMadre(e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="ocupacionMadre">Ocupación</label>
                                                                <input type="text" name="ocupacion-madre" className="form-control" id="ocupacionMadre" value={ocupacionMadre} onChange={(e) => setOcupacionMadre(e.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="nombrePadre">Nombre del padre</label>
                                                                <input type="text" name="nombre-padre" className="form-control" id="nombrePadre" value={nombrePadre} onChange={(e) => setNombrePadre(e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="docPadre">Número de documento</label>
                                                                <input type="text" name="doc-padre" className="form-control" id="docPadre" value={documentoPadre} onChange={(e) => setDocumentoPadre(e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="telPadre">Teléfono</label>
                                                                <input type="text" name="tel-padre" className="form-control" id="telPadre" value={telefonoPadre} onChange={(e) => setTelefonoPadre(e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="ocupacionPadre">Ocupación</label>
                                                                <input type="text" name="ocupacion-padre" className="form-control" id="ocupacionPadre" value={ocupacionPadre} onChange={(e) => setOcupacionPadre(e.target.value)} />
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row" style={{ marginTop: '20px', marginBottom: '30px' }}>
                                            <div className="col-md-6">
                                                <button type="submit" className="btn btn-primary">
                                                    Guardar cambios&nbsp;
                                                    {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null}

                                                </button>&nbsp;

                                                {
                                                    estadoPaciente == '1' ? (<Link to={rutaAtenderPaciente} className={'btn btn-primary'}>Atender paciente</Link>) : null
                                                }
                                                &nbsp;
                                                {pacienteId ? (
                                                    <Link to={`/paciente-planes-sesiones?pacienteId=${pacienteId}`} className="btn btn-outline-info">
                                                        Citas / Planes
                                                    </Link>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </section>
                </div>

                <Modal show={showModal} onHide={handleCloseModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Datos del paciente completados</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>{mensajeModal}</p>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseModal}>No</Button>
                        <Button variant="primary" onClick={handleAtenderPaciente}>Si</Button>
                    </Modal.Footer>
                </Modal>


                <Footer showToast={false} delay={0} />
            </div>

        );
    }

    return (
        <Loading />
    );
}
export default EditarPaciente;